module.exports = __webpack_public_path__ + "img/bookmark-check.d56e9767.svg";